<script lang="ts" setup>
const emit = defineEmits(['close'])
const { updatePassword } = useAuthStore()

const onSubmit = async (data) => {
  try {
    await updatePassword(data)
    emit('close')
  } catch (error) {
    console.error(error)
  }
}
</script>

<template>
  <ModalFullScreen
    title="Alterar senha"
    description="Digite a nova senha para atualizar"
  >
    <FormKit
      dirty-behavior="compare"
      type="form"
      @submit="onSubmit"
    >
      <FormKit
        type="password"
        name="password"
        label="Nova Senha"
        validation="required"
        validation-visibility="live"
      />
      <FormKit
        type="password"
        name="password_confirm"
        label="Confirmar Senha"
        validation="required|confirm|length:6"
        validation-visibility="live"
        validation-label="Confirmação de senha"
      />
    </FormKit>
  </ModalFullScreen>
</template>
